(() => {
  const instances = new Map();
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const routes = window.PraviloTheme?.routes || { cart: '/cart', cartAdd: '/cart/add' };

  const money = (cents, currency = 'EUR') =>
    new Intl.NumberFormat(document.documentElement.lang || 'de-DE', { style: 'currency', currency }).format((Number(cents) || 0) / 100);

  /* ---------- Warenkorb-Drawer ---------- */
  const drawer = document.querySelector('[data-cart-drawer]');
  const updateCount = count => {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = count;
      el.classList.remove('is-bumped');
      if (!reduced.matches) { void el.offsetWidth; el.classList.add('is-bumped'); }
    });
    document.querySelectorAll('[data-cart-link]').forEach(link => link.setAttribute('aria-label', `Warenkorb, ${count} Artikel`));
  };
  const renderCart = (cart, addedTitle, status) => {
    if (!drawer) return;
    const list = drawer.querySelector('[data-cart-items]');
    /* Jede Position mit Minus, Plus und Entfernen; Änderungen laufen über /cart/change.js */
    list.replaceChildren(...cart.items.map(item => {
      const li = document.createElement('li');
      li.dataset.key = item.key;
      const img = document.createElement('img');
      img.src = item.image || ''; img.alt = ''; img.width = 84; img.height = 84; img.loading = 'lazy';
      const text = document.createElement('div');
      const h3 = document.createElement('h3');
      const link = document.createElement('a'); link.href = item.url; link.textContent = item.product_title;
      h3.append(link);
      const meta = document.createElement('p');
      meta.textContent = item.variant_title || '';
      const controls = document.createElement('div');
      controls.className = 'drawer-qty';
      const step = (delta, label, symbol) => {
        const button = document.createElement('button');
        button.type = 'button'; button.className = 'drawer-qty-step';
        button.dataset.cartChange = String(item.quantity + delta); button.dataset.action = delta < 0 ? 'minus' : 'plus';
        button.setAttribute('aria-label', `${label}: ${item.product_title}`);
        button.textContent = symbol;
        if (delta > 0 && item.quantity >= 99) button.disabled = true;
        return button;
      };
      const value = document.createElement('span');
      value.className = 'drawer-qty-value'; value.textContent = item.quantity;
      value.setAttribute('aria-label', `Anzahl ${item.quantity}`);
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'drawer-remove'; remove.dataset.cartChange = '0'; remove.dataset.action = 'remove';
      remove.setAttribute('aria-label', `Entfernen: ${item.product_title}`);
      remove.textContent = 'Entfernen';
      controls.append(step(-1, 'Eins weniger', '−'), value, step(1, 'Eins mehr', '+'), remove);
      if (meta.textContent) text.append(h3, meta, controls); else text.append(h3, controls);
      const price = document.createElement('strong'); price.textContent = money(item.final_line_price, cart.currency);
      li.append(img, text, price);
      return li;
    }));
    if (!cart.items.length) {
      const empty = document.createElement('li');
      empty.className = 'cart-drawer-empty';
      empty.textContent = 'Dein Warenkorb ist leer.';
      list.append(empty);
    }
    drawer.querySelector('.cart-drawer-foot')?.toggleAttribute('hidden', !cart.items.length);
    drawer.querySelector('[data-cart-total]').textContent = money(cart.total_price, cart.currency);
    const free = drawer.querySelector('[data-free-ship]');
    if (free) {
      const threshold = Number(free.dataset.freeShip) || 0;
      const missing = threshold - cart.total_price;
      free.hidden = !threshold || !cart.item_count;
      free.querySelector('[data-free-ship-text]').textContent = missing > 0
        ? `Noch ${money(missing, cart.currency)} bis zum kostenlosen Versand innerhalb Deutschlands.`
        : 'Versand innerhalb Deutschlands ist für diese Bestellung kostenlos.';
      free.querySelector('.free-ship-bar span').style.setProperty('--progress', Math.min(1, cart.total_price / threshold).toFixed(3));
    }
    drawer.querySelector('[data-cart-added]').textContent = status || (addedTitle ? `${addedTitle} wurde hinzugefügt.` : '');
    /* „Passt dazu“: die ersten drei Vorschläge, die noch nicht im Warenkorb liegen */
    const upsellList = drawer.querySelector('[data-upsell-list]');
    if (upsellList) {
      const inCart = new Set(cart.items.map(item => String(item.product_id)));
      let shown = 0;
      upsellList.querySelectorAll('[data-upsell]').forEach(item => {
        const show = cart.item_count > 0 && !inCart.has(item.dataset.upsell) && shown < 3;
        item.hidden = !show;
        if (show) shown += 1;
      });
      upsellList.hidden = shown === 0;
    }
  };
  const openDrawer = () => {
    if (!drawer || drawer.open) return;
    drawer.classList.remove('is-closing');
    drawer.showModal();
    drawer.querySelector('[data-cart-close]')?.focus();
  };
  const closeDrawer = () => {
    if (!drawer?.open || drawer.classList.contains('is-closing')) return;
    if (reduced.matches) { drawer.close(); return; }
    drawer.classList.add('is-closing');
    let done = false;
    const finish = () => { if (done) return; done = true; drawer.classList.remove('is-closing'); drawer.close(); };
    drawer.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, 320); // Fallback, falls kein animationend eintrifft
  };
  /* Menge im Seitenfenster ändern oder Position entfernen */
  const changeLine = async button => {
    const li = button.closest('li[data-key]');
    const list = drawer.querySelector('[data-cart-items]');
    if (!li || list.getAttribute('aria-busy') === 'true') return;
    const quantity = Math.max(0, Number(button.dataset.cartChange) || 0);
    const title = li.querySelector('h3 a')?.textContent || 'Artikel';
    const action = button.dataset.action;
    list.setAttribute('aria-busy', 'true');
    list.querySelectorAll('button').forEach(b => { b.disabled = true; });
    try {
      const response = await fetch(`${routes.cartChange || '/cart/change'}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: li.dataset.key, quantity })
      });
      const cart = await response.json();
      if (!response.ok) throw new Error(cart.description || '');
      renderCart(cart, null, quantity === 0 ? `${title} wurde entfernt.` : `${title}: Anzahl ${quantity}.`);
      updateCount(cart.item_count);
      /* Fokus bleibt an derselben Stelle, auch wenn die Liste neu gezeichnet wurde */
      const same = drawer.querySelector(`li[data-key="${CSS.escape(li.dataset.key)}"] [data-action="${action}"]:not(:disabled)`);
      (same || drawer.querySelector('li[data-key] .drawer-remove') || drawer.querySelector('[data-cart-close]'))?.focus();
    } catch (error) {
      list.querySelectorAll('button').forEach(b => { b.disabled = false; });
      drawer.querySelector('[data-cart-added]').textContent = error.message || 'Die Anzahl konnte gerade nicht geändert werden. Bitte versuche es noch einmal.';
    } finally {
      list.removeAttribute('aria-busy');
    }
  };
  drawer?.querySelector('[data-cart-items]')?.addEventListener('click', event => {
    const button = event.target.closest('[data-cart-change]');
    if (button && !button.disabled) changeLine(button);
  });

  drawer?.addEventListener('click', event => {
    if (event.target === drawer || event.target.closest('[data-cart-close]')) closeDrawer();
  });
  drawer?.addEventListener('cancel', event => { event.preventDefault(); closeDrawer(); });
  drawer?.addEventListener('keydown', event => { if (event.key === 'Escape') { event.preventDefault(); closeDrawer(); } });

  /* Legt eine Variante per Ajax in den Warenkorb und zeigt den Drawer. Wirft bei Fehlern mit Shopifys Meldung. */
  const addToCart = async (id, quantity = 1) => {
    const body = new URLSearchParams({ id: String(id), quantity: String(quantity) });
    const response = await fetch(`${routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || 'Diese Größe ist gerade nicht verfügbar.');
    const cart = await (await fetch(`${routes.cart}.js`, { headers: { Accept: 'application/json' } })).json();
    renderCart(cart, data.product_title);
    updateCount(cart.item_count);
    openDrawer();
    return data;
  };
  /* Warenkorb-Symbol öffnet überall das Seitenfenster statt der Warenkorbseite (mit Strg/Cmd oder ohne Drawer bleibt es ein Link) */
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-cart-link]');
    if (!link || !drawer || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    if (location.pathname === routes.cart) return;
    event.preventDefault();
    try {
      const cart = await (await fetch(`${routes.cart}.js`, { headers: { Accept: 'application/json' } })).json();
      renderCart(cart);
      updateCount(cart.item_count);
      openDrawer();
    } catch {
      location.href = link.href;
    }
  });
  /* Für andere Bausteine (z. B. Supplements-Karussell) */
  window.PraviloTheme = Object.assign(window.PraviloTheme || {}, { addToCart });

  /* Seitenfenster (z. B. Größentabelle): gleiche Bewegung wie der Warenkorb */
  const openSheet = sheet => {
    if (!sheet || sheet.open) return;
    sheet.classList.remove('is-closing');
    sheet.showModal();
    sheet.querySelector('[data-sheet-close]')?.focus();
  };
  const closeSheet = sheet => {
    if (!sheet?.open || sheet.classList.contains('is-closing')) return;
    if (reduced.matches) { sheet.close(); return; }
    sheet.classList.add('is-closing');
    let done = false;
    const finish = () => { if (done) return; done = true; sheet.classList.remove('is-closing'); sheet.close(); };
    sheet.addEventListener('animationend', finish, { once: true });
    setTimeout(finish, 320);
  };
  document.addEventListener('click', event => {
    const sheet = event.target.closest('dialog.side-sheet');
    if (sheet && (event.target === sheet || event.target.closest('[data-sheet-close]'))) closeSheet(sheet);
  });
  document.querySelectorAll('dialog.side-sheet').forEach(sheet => sheet.addEventListener('cancel', event => { event.preventDefault(); closeSheet(sheet); }));

  /* ---------- Schnellkauf auf Karten, an Look-Punkten und im Warenkorb ---------- */
  const closeQuickAdds = except => document.querySelectorAll('[data-qa].is-open').forEach(qa => {
    if (qa === except) return;
    qa.classList.remove('is-open');
    qa.querySelector('[data-qa-panel]').hidden = true;
    qa.querySelector('[data-qa-open]').setAttribute('aria-expanded', 'false');
  });
  document.addEventListener('click', event => { if (!event.target.closest('[data-qa]')) closeQuickAdds(); });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = document.querySelector('[data-qa].is-open');
    if (!open) return;
    closeQuickAdds();
    open.querySelector('[data-qa-open]').focus();
  });
  const mountQuickAdd = qa => {
    const variants = JSON.parse(qa.querySelector('[data-qa-variants]').textContent || '[]');
    const colorIndex = Number(qa.dataset.colorIndex);
    const sizeIndex = Number(qa.dataset.sizeIndex);
    const panel = qa.querySelector('[data-qa-panel]');
    const opener = qa.querySelector('[data-qa-open]');
    const sizes = qa.querySelector('[data-qa-sizes]');
    const message = qa.querySelector('[data-qa-msg]');
    const colorName = qa.querySelector('[data-qa-color-name]');
    const colorButtons = [...qa.querySelectorAll('[data-qa-color]')];
    const firstAvailable = variants.find(v => v.available) || variants[0];
    let color = colorIndex >= 0 ? firstAvailable?.options[colorIndex] : null;

    const renderSizes = () => {
      if (colorName) colorName.textContent = color ? `, ${color}` : '';
      colorButtons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.qaColor === color)));
      const list = variants.filter(v => colorIndex < 0 || v.options[colorIndex] === color);
      sizes.replaceChildren(...list.map(variant => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'qa-size';
        button.textContent = sizeIndex >= 0 ? variant.options[sizeIndex] : 'In den Warenkorb';
        button.disabled = !variant.available;
        if (!variant.available) button.setAttribute('aria-label', `${button.textContent}, ausverkauft`);
        button.addEventListener('click', async () => {
          message.textContent = '';
          button.classList.add('is-loading');
          sizes.setAttribute('aria-busy', 'true');
          try {
            await addToCart(variant.id);
            closeQuickAdds();
          } catch (error) {
            message.textContent = error.message;
          } finally {
            button.classList.remove('is-loading');
            sizes.removeAttribute('aria-busy');
          }
        });
        return button;
      }));
    };
    colorButtons.forEach(button => button.addEventListener('click', () => { color = button.dataset.qaColor; renderSizes(); }));
    opener.addEventListener('click', event => {
      event.preventDefault();
      const open = !qa.classList.contains('is-open');
      closeQuickAdds(qa);
      qa.classList.toggle('is-open', open);
      panel.hidden = !open;
      opener.setAttribute('aria-expanded', String(open));
      if (open) { renderSizes(); (sizes.querySelector('button:not(:disabled)') || panel.querySelector('button'))?.focus({ preventScroll: true }); }
    });
    qa.querySelector('[data-qa-close]')?.addEventListener('click', () => { closeQuickAdds(); opener.focus(); });
  };
  const mountedQuickAdds = new WeakSet();
  const initQuickAdds = scope => scope.querySelectorAll('[data-qa]').forEach(qa => {
    if (mountedQuickAdds.has(qa)) return;
    mountedQuickAdds.add(qa);
    mountQuickAdd(qa);
  });
  initQuickAdds(document);
  document.addEventListener('shopify:section:load', event => initQuickAdds(event.target));

  /* ---------- Mobile Navigation ---------- */
  const closeMenus = (focusSummary = false) => document.querySelectorAll('.mobile-nav[open]').forEach(menu => {
    menu.open = false;
    if (focusSummary) menu.querySelector('summary').focus();
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenus(true); });
  document.addEventListener('click', event => {
    document.querySelectorAll('.mobile-nav[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('.mobile-sheet a')) menu.open = false;
    });
  });
  /* Das Menü beginnt direkt unter dem Kopf, auch wenn darüber noch ein Hinweisbalken steht */
  const placeSheet = menu => menu.style.setProperty('--sheet-top', `${Math.max(0, menu.closest('.site-header')?.getBoundingClientRect().bottom ?? 0)}px`);
  document.querySelectorAll('.mobile-nav').forEach(menu => menu.querySelector('summary')?.addEventListener('click', () => placeSheet(menu)));
  document.querySelectorAll('.mobile-nav').forEach(menu => menu.addEventListener('toggle', () => {
    if (menu.open) placeSheet(menu);
    document.documentElement.style.overflow = menu.open ? 'hidden' : '';
    if (menu.open) menu.querySelector('.mobile-sheet a')?.focus({ preventScroll: true });
  }));

  /* ---------- Übergang Produktbild → Detailseite (View Transitions) ---------- */
  document.addEventListener('click', event => {
    const link = event.target.closest('[data-vt-link], .pv-cta');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey) return;
    document.querySelectorAll('[style*="view-transition-name"]').forEach(el => { el.style.viewTransitionName = ''; });
    const card = link.closest('.product-card');
    const image = card ? card.querySelector('.card-img-primary') : document.querySelector('.pv-item.is-active img');
    if (image) image.style.viewTransitionName = 'pv-product';
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('.card-img-primary, .pv-item img').forEach(el => { el.style.viewTransitionName = ''; });
  });

  function mount(scope = document) {
    /* Bald erhältlich: Karussell mit zentralem Produkt (Klick, Pfeile, Tastatur, Wischen) */
    scope.querySelectorAll('[data-coming]').forEach(el => {
      if (instances.has(el)) return;
      const controller = new AbortController();
      const { signal } = controller;
      const items = [...el.querySelectorAll('[data-coming-item]')];
      const names = [...el.querySelectorAll('[data-coming-name]')];
      const current = el.querySelector('[data-coming-current]');
      let active = 0;
      let swiped = false;
      const layout = () => {
        const n = items.length;
        items.forEach((item, i) => {
          let offset = i - active;
          if (offset > n / 2) offset -= n;
          if (offset < -n / 2) offset += n;
          item.style.setProperty('--offset', offset);
          item.style.zIndex = String(10 - Math.abs(offset));
          item.classList.toggle('is-active', offset === 0);
          item.classList.toggle('is-far', Math.abs(offset) > 1);
          const button = item.querySelector('[data-coming-select]');
          if (offset === 0) button.setAttribute('aria-current', 'true'); else button.removeAttribute('aria-current');
          button.tabIndex = Math.abs(offset) > 1 ? -1 : 0;
        });
        names.forEach((name, i) => { name.hidden = i !== active; });
        if (current) current.textContent = String(active + 1);
      };
      const go = index => { active = (index + items.length) % items.length; layout(); };
      el.querySelectorAll('[data-coming-select]').forEach(button => button.addEventListener('click', () => { if (swiped) { swiped = false; return; } go(Number(button.dataset.comingSelect)); }, { signal }));
      el.querySelectorAll('[data-coming-step]').forEach(button => button.addEventListener('click', () => go(active + Number(button.dataset.comingStep)), { signal }));
      el.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        go(active + (event.key === 'ArrowRight' ? 1 : -1));
        items[active].querySelector('[data-coming-select]').focus({ preventScroll: true });
      }, { signal });
      const track = el.querySelector('[data-coming-track]');
      let startX = null;
      track.addEventListener('pointerdown', event => { startX = event.clientX; }, { signal });
      track.addEventListener('pointerup', event => {
        if (startX === null) return;
        const dx = event.clientX - startX;
        startX = null;
        swiped = Math.abs(dx) > 40;
        if (swiped) go(active + (dx < 0 ? 1 : -1));
      }, { signal });
      layout();
      instances.set(el, () => controller.abort());
    });

    /* Produktfotos mit eigenem Hintergrund (z. B. Model-Fotos eines Anbieters) erkennen: Ecken nicht weiß.
       Solche Fotos füllen Kachel und Galerie randlos, statt wie ein Freisteller mit Rand zu erscheinen. */
    const markPhoto = img => {
      const test = () => {
        try {
          /* Feines Raster, damit nur die äußersten Ecken zählen (ein Shirt nahe am Rand darf nicht mitgezählt werden).
             Foto nur, wenn alle vier Ecken deutlich farbig sind. */
          const size = 64;
          const c = document.createElement('canvas'); c.width = c.height = size;
          const g = c.getContext('2d', { willReadFrequently: true });
          g.drawImage(img, 0, 0, size, size);
          const d = g.getImageData(0, 0, size, size).data;
          const corner = (x, y) => { const i = (y * size + x) * 4; return d[i + 3] > 245 && (d[i] < 238 || d[i + 1] < 238 || d[i + 2] < 238); }; /* transparent zählt als freigestellt */
          const photo = corner(1, 1) && corner(size - 2, 1) && corner(1, size - 2) && corner(size - 2, size - 2);
          img.classList.toggle('is-photo', photo);
        } catch { /* fremde Herkunft: unverändert lassen */ }
      };
      if (img.complete && img.naturalWidth) test(); else img.addEventListener('load', test, { once: true });
    };
    scope.querySelectorAll('.card-img-product, .product-gallery-image:not(.is-model) img').forEach(markPhoto);

    /* Produktkarten mit Rückseite: auf Touch-Geräten wischt man zwischen Vorder- und Rückseite */
    scope.querySelectorAll('.product-card.has-back').forEach(card => {
      if (instances.has(card)) return;
      const media = card.querySelector('.product-card-media');
      const dots = card.querySelectorAll('.card-dots > span');
      if (!media || dots.length < 2) return;
      const controller = new AbortController();
      const mark = () => {
        const back = media.scrollLeft > media.clientWidth / 2;
        dots[0].classList.toggle('is-active', !back);
        dots[1].classList.toggle('is-active', back);
      };
      media.addEventListener('scroll', mark, { passive: true, signal: controller.signal });
      mark();
      instances.set(card, () => controller.abort());
    });

    /* Einmaliger Hinweis auf Touch-Geräten: Die erste sichtbare Karte lugt kurz zur Rückseite und gleitet zurück.
       Nur einmal pro Besuch, nicht bei reduzierter Bewegung. */
    const touch = document.documentElement.classList.contains('touch-ui') || window.matchMedia('(hover: none)').matches;
    let peeked = false;
    try { peeked = sessionStorage.getItem('pv-card-peek') === '1'; } catch {}
    if (touch && !reduced.matches && !peeked && 'IntersectionObserver' in window) {
      const first = scope.querySelector('.product-card.has-back .product-card-media');
      if (first) {
        const io = new IntersectionObserver(([entry]) => {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.9) return;
          io.disconnect();
          try { sessionStorage.setItem('pv-card-peek', '1'); } catch {}
          setTimeout(() => {
            if (first.scrollLeft > 0) return;
            first.style.scrollSnapType = 'none';
            first.scrollTo({ left: first.clientWidth * 0.28, behavior: 'smooth' });
            setTimeout(() => {
              if (first.scrollLeft < first.clientWidth * 0.5) first.scrollTo({ left: 0, behavior: 'smooth' });
              setTimeout(() => first.style.removeProperty('scroll-snap-type'), 600);
            }, 650);
          }, 400);
        }, { threshold: 0.9 });
        io.observe(first);
      }
    }

    /* Produktformular: Farb-/Größenwahl, Anzahl, Ajax-Warenkorb */
    scope.querySelectorAll('[data-product]').forEach(el => {
      if (instances.has(el)) return;
      const form = el.querySelector('form.product-form');
      const select = el.querySelector('[data-variant]');
      if (!form || !select) return;
      const controller = new AbortController();
      const { signal } = controller;
      const variants = JSON.parse(el.querySelector('[data-variants]')?.textContent || '[]');
      /* Nach Optionsnummer sortiert: Die Farbe steht vorne, kann bei Spreadshirt aber Option 2 sein */
      const groups = [...el.querySelectorAll('[data-option-group]')].sort((a, b) => a.dataset.optionGroup - b.dataset.optionGroup);
      const add = el.querySelector('[data-add]');
      const addLabel = el.querySelector('[data-add-label]');
      const message = el.querySelector('[data-form-message]');
      const quantity = el.querySelector('.quantity');
      const bar = el.querySelector('[data-pdp-bar]');
      const barChoice = el.querySelector('[data-bar-choice]');
      const barAdd = el.querySelector('[data-bar-add]');

      /* Galerie nach Farbe: Es stehen nur die Fotos der gewählten Farbe in der Galerie (Model-Fotos nur in der Model-Farbe).
         So passt das Bild immer zur Auswahl, und die Seite springt nicht zu einem Foto weiter unten. */
      const gallery = el.querySelector('[data-gallery]');
      const colorIndex = groups.findIndex(group => group.classList.contains('is-color'));
      const norm = value => (value || '').trim().toLowerCase();
      const colorValues = colorIndex > -1 ? [...groups[colorIndex].querySelectorAll('input')].map(input => norm(input.value)) : [];
      const slides = gallery ? [...gallery.querySelectorAll('.product-gallery-image')] : [];
      slides.forEach(slide => { if (slide.dataset.color && !colorValues.includes(norm(slide.dataset.color))) delete slide.dataset.color; });
      if (colorIndex > -1) variants.forEach(v => {
        const node = v.image && document.getElementById(v.image);
        if (node && !node.dataset.color) node.dataset.color = v.options[colorIndex];
      });
      /* Fotos ohne Farbangabe (z. B. Rückseite direkt nach dem Variantenfoto): übernehmen die Farbe des Fotos davor */
      if (colorIndex > -1) slides.reduce((prev, slide) => {
        if (slide.classList.contains('is-model')) return prev;
        if (!slide.dataset.color && prev) slide.dataset.color = prev;
        return slide.dataset.color || prev;
      }, '');
      let shownColor = null;
      const showColor = (color, userChange) => {
        if (!gallery || colorIndex < 0) return;
        const wanted = norm(color);
        if (wanted === shownColor) return;
        shownColor = wanted;
        const matches = slides.filter(slide => norm(slide.dataset.color) === wanted);
        slides.forEach(slide => { slide.hidden = matches.length > 0 && Boolean(slide.dataset.color) && !matches.includes(slide); });
        /* Die Fotos der neuen Farbe sofort laden, statt auf das Lazy-Loading zu warten */
        matches.forEach(slide => slide.querySelectorAll('img[loading="lazy"]').forEach(img => { img.loading = 'eager'; }));
        gallery.classList.toggle('is-flat', matches.length > 0 && !matches.some(slide => slide.classList.contains('is-model')));
        /* Farbe ohne eigenes Foto: alle Fotos bleiben sichtbar, ein Hinweis sagt, dass sie eine andere Farbe zeigen */
        const missing = el.querySelector('[data-gallery-missing]');
        if (missing) {
          const known = slides.some(slide => slide.dataset.color);
          missing.hidden = !(known && matches.length === 0);
          missing.textContent = `Für ${color.trim()} gibt es noch kein eigenes Foto. Die Bilder zeigen andere Farben.`;
        }
        gallery.dispatchEvent(new Event('gallery-change'));
        if (!userChange) return;
        const behavior = reduced.matches ? 'instant' : 'smooth';
        if (window.matchMedia('(max-width: 760px)').matches) { gallery.scrollTo({ left: 0, behavior }); return; }
        /* Desktop: Liegt der Anfang der Galerie oberhalb des Bildschirms, ruhig zum ersten Foto der Farbe hochscrollen. */
        const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 72;
        const top = gallery.getBoundingClientRect().top;
        if (top < header) window.scrollTo({ top: window.scrollY + top - header - 32, behavior });
      };
      const selectedOptions = () => groups.map(group => group.querySelector('input:checked')?.value);
      const markAvailability = () => {
        const current = selectedOptions();
        groups.forEach((group, index) => group.querySelectorAll('.option-pill').forEach(pill => {
          const value = pill.querySelector('input').value;
          const ok = variants.some(v => v.available && v.options[index] === value && v.options.every((o, i) => i === index || o === current[i]));
          pill.classList.toggle('is-unavailable', !ok);
        }));
      };
      const apply = variant => {
        if (!variant) return;
        select.value = String(variant.id);
        el.querySelectorAll('[data-price]').forEach(node => { node.textContent = variant.price; });
        add.disabled = !variant.available;
        addLabel.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
        if (barChoice) barChoice.textContent = variant.title;
        if (barAdd) { barAdd.disabled = !variant.available; barAdd.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft'; }
        groups.forEach((group, i) => {
          const input = [...group.querySelectorAll('input')].find(inp => inp.value === variant.options[i]);
          if (input) input.checked = true;
          group.querySelector('[data-option-current]').textContent = variant.options[i] || '';
        });
        markAvailability();
        const url = new URL(location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url);
        if (colorIndex > -1) showColor(variant.options[colorIndex], true);
      };

      if (groups.length && variants.length) {
        groups.forEach(group => { group.hidden = false; });
        form.classList.add('has-pickers');
        const position = (i, value) => [...groups[i].querySelectorAll('input')].findIndex(input => input.value === value);
        groups.forEach((group, index) => group.addEventListener('change', () => {
          const wanted = selectedOptions();
          const exact = variants.find(v => v.options.every((o, i) => o === wanted[i]));
          /* Farbwechsel: Ist die gewählte Größe in der neuen Farbe ausverkauft, die nächstliegende lieferbare Größe nehmen.
             Bei einem Klick auf eine Größe bleibt die Farbe dagegen stehen. */
          if (index === colorIndex && exact && !exact.available) {
            const distance = v => v.options.reduce((sum, o, i) => sum + (i === index ? 0 : Math.abs(position(i, o) - position(i, wanted[i]))), 0);
            const near = variants.filter(v => v.available && v.options[index] === wanted[index]).sort((a, b) => distance(a) - distance(b))[0];
            if (near) { apply(near); return; }
          }
          const fallback = variants.find(v => v.available && v.options[index] === wanted[index]) || variants.find(v => v.options[index] === wanted[index]);
          apply(exact || fallback);
        }, { signal }));
        markAvailability();
        const start = variants.find(v => String(v.id) === select.value);
        if (start && colorIndex > -1) showColor(start.options[colorIndex], false);
      }
      select.addEventListener('change', () => apply(variants.find(v => String(v.id) === select.value)), { signal });

      el.querySelectorAll('[data-step]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => {
          quantity.value = Math.min(99, Math.max(1, (parseInt(quantity.value, 10) || 1) + Number(button.dataset.step)));
        }, { signal });
      });

      form.addEventListener('submit', async event => {
        if (!window.fetch || !drawer) return;
        event.preventDefault();
        message.hidden = true;
        add.classList.add('is-loading');
        add.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(`${routes.cartAdd}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new URLSearchParams(new FormData(form)) });
          const data = await response.json().catch(() => ({}));
          if (!response.ok) {
            message.textContent = data.description || 'Diese Variante konnte nicht hinzugefügt werden. Bitte wähle eine andere Größe oder Farbe.';
            message.hidden = false;
            return;
          }
          const cart = await (await fetch(`${routes.cart}.js`, { headers: { Accept: 'application/json' } })).json();
          renderCart(cart, data.product_title);
          updateCount(cart.item_count);
          openDrawer();
        } catch {
          form.submit();
        } finally {
          add.classList.remove('is-loading');
          add.removeAttribute('aria-busy');
        }
      }, { signal });

      /* Mobile Kaufleiste: erscheint, sobald der Kaufknopf aus dem Bild ist, und verschwindet am Seitenende */
      if (bar && 'IntersectionObserver' in window) {
        const setBar = visible => {
          bar.classList.toggle('is-visible', visible);
          bar.toggleAttribute('inert', !visible);
          bar.setAttribute('aria-hidden', String(!visible));
        };
        let addVisible = true, footVisible = false;
        const footer = document.querySelector('.site-footer');
        const io = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (entry.target === add) addVisible = entry.isIntersecting || entry.boundingClientRect.top > 0;
            else footVisible = entry.isIntersecting;
          });
          setBar(!addVisible && !footVisible);
        });
        io.observe(add);
        if (footer) io.observe(footer);
        signal.addEventListener('abort', () => io.disconnect());
        barAdd?.addEventListener('click', () => form.requestSubmit(add), { signal });
      }

      /* Bildpunkte der mobilen Galerie */
      const dots = el.querySelector('[data-gallery-dots]');
      if (gallery && dots) {
        /* Zählt nur die Fotos der gewählten Farbe. Viele Bilder: Zähler statt Punktreihe, damit nichts über den Rand läuft */
        let visible = [], counter = false;
        const mark = () => {
          const index = Math.min(Math.round(gallery.scrollLeft / Math.max(1, visible[0]?.offsetWidth + 12)), visible.length - 1);
          if (counter) { dots.textContent = `${index + 1} / ${visible.length}`; return; }
          [...dots.children].forEach((dot, i) => dot.classList.toggle('is-active', i === index));
        };
        const build = () => {
          visible = slides.filter(slide => !slide.hidden);
          counter = visible.length > 9;
          dots.classList.toggle('is-counter', counter);
          dots.replaceChildren(...(counter ? [] : visible.map(() => document.createElement('span'))));
          dots.hidden = visible.length < 2;
          mark();
        };
        gallery.addEventListener('scroll', mark, { passive: true, signal });
        gallery.addEventListener('gallery-change', build, { signal });
        build();
      }

      el.querySelectorAll('[data-open-size-guide]').forEach(link => link.addEventListener('click', event => {
        const sheet = el.querySelector('[data-size-guide]');
        if (!sheet) return;
        event.preventDefault();
        openSheet(sheet);
      }, { signal }));

      instances.set(el, () => controller.abort());
    });
  }

  /* Lieferanzeige: voraussichtlicher Zeitraum in Werktagen (Mo–Fr, ohne bundesweite Feiertage) */
  function mountDelivery(scope = document) {
    const easter = y => {
      const a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
      const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
      return new Date(y, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1);
    };
    const key = d => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
    const holidays = new Set();
    const y0 = new Date().getFullYear();
    for (const y of [y0, y0 + 1]) {
      [[0, 1], [4, 1], [9, 3], [11, 25], [11, 26]].forEach(([m, d]) => holidays.add(key(new Date(y, m, d))));
      const e = easter(y);
      [-2, 1, 39, 50].forEach(offset => holidays.add(key(new Date(y, e.getMonth(), e.getDate() + offset))));
    }
    const addWorkdays = (date, days) => {
      const d = new Date(date);
      while (days > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6 && !holidays.has(key(d))) days -= 1;
      }
      return d;
    };
    const fmt = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: 'numeric', month: 'short' });
    scope.querySelectorAll('[data-delivery-steps]').forEach(el => {
      const min = Number(el.dataset.min), max = Number(el.dataset.max);
      const out = el.querySelector('[data-delivery-range]');
      if (!out || !(min > 0 && max >= min)) return;
      const today = new Date();
      /* Jedes Datum bleibt in einer Zeile, umbrochen wird nur nach dem Strich */
      const day = d => fmt.format(d).replace(/ /g, '\u00a0');
      out.textContent = `${day(addWorkdays(today, min))} – ${day(addWorkdays(today, max))}`;
    });
  }

  /* Kategorieseiten: Sortieren innerhalb jeder Produktgruppe */
  function mountSort(scope = document) {
    scope.querySelectorAll('[data-sort-scope]').forEach(el => {
      const select = el.querySelector('[data-sort-select]');
      if (!select || instances.has(select)) return;
      const controller = new AbortController();
      let ranks = {};
      try { ranks = JSON.parse(el.querySelector('[data-rank-map]')?.textContent || '{}'); } catch {}
      const grids = [...el.querySelectorAll('.catalogue-grid')];
      grids.forEach(grid => [...grid.children].forEach((card, i) => { card.dataset.order = String(i); }));
      const keys = {
        '': c => Number(c.dataset.order),
        rank: c => (ranks[c.dataset.handle] || 9999) * 1000 + Number(c.dataset.order),
        new: c => -Number(c.dataset.new || 0),
        'price-asc': c => Number(c.dataset.price || 0),
        'price-desc': c => -Number(c.dataset.price || 0)
      };
      select.addEventListener('change', () => {
        const key = keys[select.value] || keys[''];
        grids.forEach(grid => {
          const cards = [...grid.querySelectorAll(':scope > .product-card')];
          cards.sort((a, b) => key(a) - key(b) || Number(a.dataset.order) - Number(b.dataset.order)).forEach(card => grid.appendChild(card));
        });
      }, { signal: controller.signal });
      instances.set(select, () => controller.abort());
    });
  }

  /* Rückseiten: aus dem Pool alle paar Sekunden einen Look weich austauschen.
     Pausiert bei Maus darüber, Tastaturfokus, Wischen, außerhalb des Bildschirms und im Hintergrund-Tab.
     Bei reduzierter Bewegung bleibt alles stehen. */
  function mountLooks(scope = document) {
    scope.querySelectorAll('[data-looks] .looks-grid').forEach(grid => {
      if (instances.has(grid)) return;
      const looks = [...grid.querySelectorAll(':scope > .look')];
      const visible = looks.filter(l => !l.hidden).slice(0, 3);
      const queue = looks.filter(l => !visible.includes(l));
      if (visible.length < 3 || !queue.length || reduced.matches) return;
      const controller = new AbortController();
      const { signal } = controller;
      grid.dataset.rotating = '';
      visible.forEach((look, i) => { look.dataset.slot = String(i); });
      let hold = false, inView = false, busy = false, resumeAt = 0, turn = 0;
      const order = [0, 2, 1];
      const wait = ms => new Promise(r => setTimeout(r, ms));
      grid.addEventListener('pointerenter', () => { hold = true; }, { signal });
      grid.addEventListener('pointerleave', () => { hold = false; }, { signal });
      grid.addEventListener('focusin', () => { hold = true; }, { signal });
      grid.addEventListener('focusout', () => { hold = grid.matches(':hover'); }, { signal });
      grid.addEventListener('scroll', () => { resumeAt = Date.now() + 8000; }, { passive: true, signal });
      grid.addEventListener('touchstart', () => { resumeAt = Date.now() + 8000; }, { passive: true, signal });
      const io = new IntersectionObserver(([e]) => { inView = e.isIntersecting; }, { threshold: 0.35 });
      io.observe(grid);
      const tick = async () => {
        if (busy || hold || !inView || document.hidden || Date.now() < resumeAt || reduced.matches) return;
        if (grid.querySelector('.qa.is-open')) return;
        busy = true;
        const slot = order[turn++ % order.length];
        const out = visible[slot];
        const next = queue.shift();
        const img = next.querySelector('img');
        if (img) { img.loading = 'eager'; try { await img.decode(); } catch {} }
        out.classList.add('is-leaving');
        await wait(520);
        next.classList.add('is-entering');
        next.dataset.slot = String(slot);
        next.hidden = false;
        grid.insertBefore(next, out);
        out.hidden = true;
        out.classList.remove('is-leaving');
        out.removeAttribute('data-slot');
        void next.offsetWidth;
        next.classList.remove('is-entering');
        visible[slot] = next;
        queue.push(out);
        busy = false;
      };
      const timer = setInterval(tick, 6000);
      instances.set(grid, () => { controller.abort(); io.disconnect(); clearInterval(timer); });
    });
  }

  /* Rückseiten-Bühne: Maus darüber wendet das Shirt mit einer Feder auf die Vorderseite und neigt es zum Zeiger,
     beim Verlassen zurück. Ein Klick (am Handy ein Tippen) öffnet das Produkt. Bei reduzierter Bewegung bleibt es stehen. */
  function mountTilt(scope = document) {
    if (reduced.matches) return;
    const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    scope.querySelectorAll('.looks-grid').forEach(grid => {
      if (instances.has(grid.parentElement)) return;
      const controller = new AbortController();
      const { signal } = controller;
      const states = new Map();
      let frame = 0;
      const stateOf = card => {
        const tilt = card?.querySelector('[data-look-turn]');
        if (!tilt) return null;
        if (!states.has(tilt)) states.set(tilt, { a: 0, v: 0, ta: 0, rx: 0, tx: 0, ty: 0, tyc: 0, s: 1, ts: 1, el: tilt });
        return states.get(tilt);
      };
      grid.querySelectorAll('.look-stage-card').forEach(card => { card.dataset.turnable = ''; });
      const step = () => {
        frame = 0;
        let moving = false;
        states.forEach(st => {
          /* Feder für die Wende (leichtes Überschwingen), weiches Nachziehen für die Neigung */
          st.v += (st.ta - st.a) * 0.003; st.v *= 0.92; st.a += st.v;
          st.rx += (st.tx - st.rx) * 0.08; st.tyc += (st.ty - st.tyc) * 0.08; st.s += (st.ts - st.s) * 0.08;
          st.el.style.setProperty('--rx', st.rx.toFixed(2) + 'deg');
          st.el.style.setProperty('--ry', (st.a + st.tyc).toFixed(2) + 'deg');
          st.el.style.setProperty('--s', st.s.toFixed(4));
          if (Math.abs(st.ta - st.a) > 0.1 || Math.abs(st.v) > 0.05 || Math.abs(st.tx - st.rx) > 0.05 || Math.abs(st.ty - st.tyc) > 0.05 || Math.abs(st.ts - st.s) > 0.001) moving = true;
        });
        if (moving) frame = requestAnimationFrame(step);
      };
      const kick = () => { if (!frame) frame = requestAnimationFrame(step); };
      if (fine) {
        grid.addEventListener('pointermove', event => {
          const card = event.target.closest('.look-stage-card');
          if (!card || event.target.closest('.look-tag')) return;
          const st = stateOf(card); if (!st) return;
          const r = card.getBoundingClientRect();
          const x = (event.clientX - r.left) / r.width - 0.5, y = (event.clientY - r.top) / r.height - 0.5;
          st.ta = 180; st.ty = -x * 22; st.tx = -y * 12; st.ts = 1.04;
          kick();
        }, { signal });
        grid.addEventListener('pointerout', event => {
          const card = event.target.closest('.look-stage-card');
          if (!card || card.contains(event.relatedTarget)) return;
          const st = stateOf(card); if (!st) return;
          st.ta = 0; st.tx = 0; st.ty = 0; st.ts = 1; kick();
        }, { signal });
      }
      instances.set(grid.parentElement, () => { controller.abort(); cancelAnimationFrame(frame); });
    });
  }

  /* Rabatt-Leiste: Klick auf den Code kopiert ihn */
  document.addEventListener('click', event => {
    const btn = event.target.closest('.promo-code[data-copy]');
    if (!btn) return;
    navigator.clipboard?.writeText(btn.dataset.copy).then(() => {
      const note = btn.parentElement.querySelector('[data-copied]');
      if (note) { note.hidden = false; setTimeout(() => { note.hidden = true; }, 1800); }
    }).catch(() => {});
  });

  function mountHome(scope = document) {
    /* Sortiment: Tabs filtern die Karten, „Mehr anzeigen“ blendet schrittweise ein */
    scope.querySelectorAll('[data-catalog]').forEach(el => {
      if (instances.has(el)) return;
      const controller = new AbortController();
      const { signal } = controller;
      const perPage = Number(el.dataset.perPage) || 8;
      const tabs = [...el.querySelectorAll('[role="tab"]')];
      const cards = [...el.querySelectorAll('[data-catalog-grid] > .product-card')];
      const more = el.querySelector('[data-catalog-more]');
      const empty = el.querySelector('[data-catalog-empty]');
      const grid = el.querySelector('[data-catalog-grid]');
      const sortSelect = el.querySelector('[data-catalog-sort]');
      cards.forEach((card, i) => { card.dataset.order = String(i); });
      let matches = cards, visible = perPage, current = tabs[0];
      const show = (animate) => {
        cards.forEach(card => { card.hidden = true; card.classList.remove('is-entering'); card.style.removeProperty('--i'); });
        matches.slice(0, visible).forEach((card, i) => {
          card.hidden = false;
          if (animate && !reduced.matches) { card.style.setProperty('--i', String(i % perPage)); void card.offsetWidth; card.classList.add('is-entering'); }
        });
        more.hidden = matches.length <= visible;
        more.textContent = `Mehr anzeigen (${matches.length - Math.min(visible, matches.length)} weitere)`;
        empty.hidden = matches.length > 0;
      };
      /* Sortieren: ordnet die Karten im Raster neu, Filter und „Mehr anzeigen“ bleiben erhalten */
      const sortKey = {
        '': c => Number(c.dataset.order),
        rank: c => Number(c.dataset.rank || 9999) * 1000 + Number(c.dataset.order),
        new: c => -Number(c.dataset.new || 0),
        'price-asc': c => Number(c.dataset.price || 0),
        'price-desc': c => -Number(c.dataset.price || 0)
      };
      const sortCards = () => {
        const key = sortKey[sortSelect?.value || ''] || sortKey[''];
        cards.sort((a, b) => key(a) - key(b) || Number(a.dataset.order) - Number(b.dataset.order));
        cards.forEach(card => grid.appendChild(card));
      };
      const select = tab => {
        current = tab;
        tabs.forEach(t => { const on = t === tab; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
        const tag = tab.dataset.tabTag, text = tab.dataset.tabText;
        matches = cards.filter(card => (!tag || card.dataset.tags.includes(`|${tag}|`)) && (!text || card.dataset.text.includes(text)));
        visible = perPage;
        show(true);
      };
      /* Leere Tabs ausblenden. Zeigt kein Tab etwas anderes als „Alle“ (z. B. nur Unisex-Shirts), fällt die Tab-Leiste weg. */
      const matchesOf = tab => cards.filter(card => (!tab.dataset.tabTag || card.dataset.tags.includes(`|${tab.dataset.tabTag}|`)) && (!tab.dataset.tabText || card.dataset.text.includes(tab.dataset.tabText)));
      tabs.forEach(tab => { tab.hidden = matchesOf(tab).length === 0; });
      const tablist = el.querySelector('[role="tablist"]');
      if (tablist) tablist.hidden = tabs.filter(tab => !tab.hidden).every(tab => matchesOf(tab).length === cards.length);
      tabs.forEach((tab, index) => {
        tab.tabIndex = index === 0 ? 0 : -1;
        tab.addEventListener('click', () => select(tab), { signal });
        tab.addEventListener('keydown', event => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const next = tabs[(index + (event.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length];
          next.focus(); select(next);
        }, { signal });
      });
      sortSelect?.addEventListener('change', () => { sortCards(); select(current || tabs[0]); }, { signal });
      more.addEventListener('click', () => {
        const first = matches[visible];
        visible += perPage; show(false);
        first?.querySelector('h3 a')?.focus({ preventScroll: true });
      }, { signal });
      show(false);
      instances.set(el, () => controller.abort());
    });

    /* „Dazu passt“: bei jedem Besuch eine andere passende Ergänzung aus dem Pool */
    scope.querySelectorAll('[data-addon-pool]').forEach(pool => {
      const items = [...pool.querySelectorAll('[data-addon]')];
      if (items.length < 2) return;
      const pick = Math.floor(Math.random() * items.length);
      items.forEach((el, i) => { el.hidden = i !== pick; });
    });
    /* Bilderleiste: wandert auf dem Desktop mit dem Scrollen seitlich durch; sonst normal wischbar */
    scope.querySelectorAll('[data-strip]').forEach(section => {
      if (instances.has(section)) return;
      const viewport = section.querySelector('[data-strip-viewport]');
      const track = section.querySelector('[data-strip-track]');
      /* Zufällige Auswahl je Besuch: mischen, gleiche Produkte nicht direkt nebeneinander, Rest entfernen */
      const show = Number(track.dataset.stripShuffle);
      if (show) {
        const items = [...track.children];
        for (let i = items.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [items[i], items[j]] = [items[j], items[i]];
        }
        for (let i = 1; i < items.length; i++) {
          if (items[i].dataset.handle !== items[i - 1].dataset.handle) continue;
          const k = items.findIndex((el, n) => n > i && el.dataset.handle !== items[i - 1].dataset.handle);
          if (k > 0) [items[i], items[k]] = [items[k], items[i]];
        }
        items.forEach((el, i) => { if (i < show) track.appendChild(el); else el.remove(); });
      }
      const desktop = window.matchMedia('(min-width: 761px)');
      let frame = 0, active = false, enabled = false, stopped = false;
      const update = () => {
        frame = 0;
        if (!enabled) return;
        const rect = section.getBoundingClientRect();
        const progress = Math.min(1, Math.max(0, (innerHeight - rect.top) / (innerHeight + rect.height)));
        const distance = Math.max(0, track.scrollWidth - viewport.clientWidth);
        track.style.transform = `translate3d(${(-progress * distance).toFixed(1)}px, 0, 0)`;
      };
      const setMode = () => {
        enabled = desktop.matches && !reduced.matches && !stopped;
        viewport.classList.toggle('is-drifting', enabled);
        if (!enabled) track.style.transform = '';
        update();
      };
      const onScroll = () => { if (active && enabled && !frame) frame = requestAnimationFrame(update); };
      const io = new IntersectionObserver(([entry]) => { active = entry.isIntersecting; onScroll(); });
      io.observe(section);
      window.addEventListener('scroll', onScroll, { passive: true });
      desktop.addEventListener('change', setMode);
      /* Maus oder Tastatur in der Leiste: Wandern anhalten, ohne Sprung (Position wird in normales Seitwärts-Scrollen übernommen),
         damit sich die Bilder bequem anklicken lassen */
      const freeze = () => {
        if (!enabled) return;
        const m = /translate3d\((-?[\d.]+)px/.exec(track.style.transform);
        const x = m ? -parseFloat(m[1]) : 0;
        stopped = true; setMode();
        viewport.scrollLeft = x;
      };
      section.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') freeze(); });
      section.addEventListener('focusin', freeze);
      setMode();
      instances.set(section, () => { io.disconnect(); window.removeEventListener('scroll', onScroll); desktop.removeEventListener('change', setMode); });
    });

    /* Hintergrund-Filme: laden erst, wenn sie ins Bild kommen; laufen nur sichtbar */
    scope.querySelectorAll('[data-bg-film]').forEach(video => {
      if (instances.has(video) || reduced.matches || navigator.connection?.saveData) return;
      const io = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; source.removeAttribute('data-src'); video.load(); });
          video.play().then(() => video.classList.add('is-playing')).catch(() => {});
        } else if (!video.paused) video.pause();
      }, { threshold: 0.25 });
      io.observe(video);
      instances.set(video, () => io.disconnect());
    });

    /* Anmeldung „Benachrichtigen“: Shopify leitet mit ?customer_posted=true zurück */
    if (location.search.includes('customer_posted=true')) {
      scope.querySelectorAll('[data-notify-done]').forEach(done => {
        done.hidden = false;
        done.closest('form')?.querySelector('.notify-row')?.setAttribute('hidden', '');
      });
    }

    /* Hauptmenü: ein heller Hintergrund gleitet mit der Maus von Punkt zu Punkt; beim Klick kurzer Druck und eine goldene Linie.
       Nur mit Maus (kein Touch), bei reduzierter Bewegung nur Ein-/Ausblenden. */
    scope.querySelectorAll('.desktop-nav').forEach(nav => {
      if (instances.has(nav) || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
      const glide = document.createElement('span');
      glide.className = 'nav-glide';
      glide.setAttribute('aria-hidden', 'true');
      nav.prepend(glide);
      const links = [...nav.querySelectorAll(':scope > a, :scope > .nav-item > a')];
      let shown = false;
      const moveTo = link => {
        const n = nav.getBoundingClientRect(), r = link.getBoundingClientRect();
        if (!shown) glide.classList.add('is-jump');
        glide.style.setProperty('--gx', `${r.left - n.left - 12}px`);
        glide.style.setProperty('--gw', `${r.width + 24}px`);
        glide.classList.add('is-on');
        if (!shown) { glide.getBoundingClientRect(); glide.classList.remove('is-jump'); }
        shown = true;
      };
      const hide = () => { glide.classList.remove('is-on'); shown = false; };
      const controller = new AbortController(), { signal } = controller;
      links.forEach(link => {
        link.addEventListener('pointerenter', () => moveTo(link), { signal });
        link.addEventListener('focus', () => { if (link.matches(':focus-visible')) moveTo(link); }, { signal });
        link.addEventListener('pointerdown', () => {
          link.classList.remove('is-tapped'); link.getBoundingClientRect(); link.classList.add('is-tapped');
          glide.classList.add('is-pressed');
        }, { signal });
        link.addEventListener('animationend', () => link.classList.remove('is-tapped'), { signal });
      });
      document.addEventListener('pointerup', () => glide.classList.remove('is-pressed'), { signal });
      nav.addEventListener('pointerleave', hide, { signal });
      nav.addEventListener('focusout', event => { if (!nav.contains(event.relatedTarget)) hide(); }, { signal });
      instances.set(nav, () => { controller.abort(); glide.remove(); });
    });

    /* Kategorie-Leiste: die aktive Kategorie steht auf dem Handy sichtbar im Bild */
    scope.querySelectorAll('.category-nav').forEach(nav => {
      const current = nav.querySelector('[aria-current="page"]');
      if (current && nav.scrollWidth > nav.clientWidth) nav.scrollLeft += current.getBoundingClientRect().left - nav.getBoundingClientRect().left - (nav.clientWidth - current.offsetWidth) / 2;
    });
  }

  document.addEventListener("shopify:section:load", event => { mount(event.target); mountHome(event.target); mountSort(event.target); mountLooks(event.target); mountTilt(event.target); mountDelivery(event.target); });
  document.addEventListener('shopify:section:unload', event => {
    for (const [el, cleanup] of instances) {
      if (event.target.contains(el)) { cleanup(); instances.delete(el); }
    }
  });
  mount();
  mountHome();
  mountSort();
  mountLooks();
  mountTilt();
  mountDelivery();
})();
